import Helmet from 'react-helmet'
import React from 'react'
import { observer } from 'mobx-react'
import { HeaderSink, HeaderTitle } from 'components/Header'
import LinkedAccountsManager from 'components/LinkedAccountsManager'
import intercomUpdate from 'decorators/intercomUpdate'

@intercomUpdate({ screen: 'Linked Accounts' })
@observer
export default class LinkedAccountsScreen extends React.Component {
  componentWillMount () {
    this.props.rootStore.linkedAccountsManager.loadAccounts()
  }

  render () {
    return (
      <div className="linked-accounts-screen">
        <Helmet title="Linked Accounts" />
        <HeaderSink small>
          <HeaderTitle>
            Linked Accounts
          </HeaderTitle>
        </HeaderSink>
        <div className="has-vspacing">
          <LinkedAccountsManager
            manager={this.props.rootStore.linkedAccountsManager}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/LinkedAccounts/index.jsx